import React, { useRef, useEffect } from 'react'
import { Link } from 'gatsby'
import linkResolver from '../utils/linkResolver'
import GlitchingChars from './GlitchingChars'

const Button = ({
	className,
	text,
	type,
	href = null,
	prismicLinkData = null,
	to = null,
	target = null,
	backgroundColor = '#2c4b48',
	borderColor = null,
	color = '#efe9e0',
	hasAnimEnter = true,
	animEnterDelay = 0
}) => {

	const buttonEl = useRef(null)
	const borderEl = useRef(null)

	/**
	 * Adapt border sizes depending on button aspect ratio
	 */
	useEffect(() => {
		if (borderEl.current === null) return
		const buttonElRect = buttonEl.current.getBoundingClientRect()
		const buttonElAspectRatio = buttonElRect.height / buttonElRect.width
		const borderRectEl = borderEl.current.querySelector('rect')
		const modifiedRectHeight = 129 * buttonElAspectRatio
		borderRectEl.setAttribute('height', modifiedRectHeight)
		borderRectEl.setAttribute('rx', modifiedRectHeight * 0.5)
		borderEl.current.setAttribute('viewBox', `0 0 130 ${modifiedRectHeight + 1}`)
	}, [])

	if (href !== null) {
		return (
			<a
				className={`Button ${className} ${hasAnimEnter === false ? 'noAnimEnter' : ''}`}
				href={href}
				target={target}
				style={{ backgroundColor: backgroundColor, color: color }}
				data-is-on-screen={hasAnimEnter}
				ref={buttonEl}
			>
				{borderColor && <svg className="Button__Border" ref={borderEl} viewBox="0 0 130 37" stroke={borderColor}><rect x=".5" y=".5" width="129" height="36" rx="18" fill="none" fillRule="evenodd"/></svg>}
				<GlitchingChars delay={animEnterDelay}>
					{text}
				</GlitchingChars>
			</a>
		)
	}
	else if (prismicLinkData !== null) {
		return (
			<Link
				className={`Button ${className} ${hasAnimEnter === false ? 'noAnimEnter' : ''}`}
				to={linkResolver(prismicLinkData)}
				style={{ backgroundColor: backgroundColor, color: color }}
				data-is-on-screen={hasAnimEnter}
				ref={buttonEl}
			>
				{borderColor && <svg className="Button__Border" ref={borderEl} viewBox="0 0 130 37" stroke={borderColor}><rect x=".5" y=".5" width="129" height="36" rx="18" fill="none" fillRule="evenodd"/></svg>}
				<GlitchingChars delay={animEnterDelay}>
					{text}
				</GlitchingChars>
			</Link>
		)
	}
	else if (to !== null) {
		return (
			<Link
				className={`Button ${className} ${hasAnimEnter === false ? 'noAnimEnter' : ''}`}
				to={to}
				style={{ backgroundColor: backgroundColor, color: color }}
				data-is-on-screen={hasAnimEnter}
				ref={buttonEl}
			>
				{borderColor && <svg className="Button__Border" ref={borderEl} viewBox="0 0 130 37" stroke={borderColor}><rect x=".5" y=".5" width="129" height="36" rx="18" fill="none" fillRule="evenodd"/></svg>}
				<GlitchingChars delay={animEnterDelay}>
					{text}
				</GlitchingChars>
			</Link>
		)
	}
	else {
		return (
			<button
				className={`Button ${className} ${hasAnimEnter === false ? 'noAnimEnter' : ''}`}
				type={type}
				style={{ backgroundColor: backgroundColor, color: color }}
				data-is-on-screen={hasAnimEnter}
				ref={buttonEl}
			>
				{borderColor && <svg className="Button__Border" ref={borderEl} viewBox="0 0 130 37" stroke={borderColor}><rect x=".5" y=".5" width="129" height="36" rx="18" fill="none" fillRule="evenodd"/></svg>}
				<GlitchingChars delay={animEnterDelay}>
					{text}
				</GlitchingChars>
			</button>
		)
	}
}

export default Button